import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    template: `
        <ion-app>
            <ion-router-outlet></ion-router-outlet>
            <cwt-ion-component-preloader></cwt-ion-component-preloader>    
        </ion-app>
    `
})
export class AppComponent { }